import { IVariable } from "../../../entities/src/variable";
import { Modelable } from "../../../entities/src/modelable";

export class Variable implements Modelable<IVariable> {
    constructor(public data: IVariable) {}
}
